"use client";

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link2, Image as ImageIcon, CheckCircle2 } from "lucide-react";

/**
 * 3D-Bühne im Hintergrund + gestochen scharfe Social-Card im Vordergrund.
 */
export default function Preview() {
  const [unfurled, setUnfurled] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setUnfurled((v) => !v), 2500);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl p-4 select-none"
      style={{ perspective: "900px" }}
    >
      <motion.div
        animate={{ scale: [1, 1.22, 1], opacity: [0.45, 0.85, 0.45] }}
        transition={{ duration: 4.5, repeat: Infinity }}
        className="pointer-events-none absolute left-1/2 top-1/2 h-40 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-rose-500/30 blur-3xl"
      />

      <div
        className="pointer-events-none absolute inset-x-[-20%] bottom-[-35%] h-[110%] opacity-45 dark:opacity-60"
        style={{
          transform: "rotateX(68deg)",
          maskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
        }}
      >
        <motion.div
          animate={{ backgroundPosition: ["0px 0px", "0px 28px"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="h-full w-full bg-[linear-gradient(to_right,rgba(244,63,94,0.3)_1px,transparent_1px),linear-gradient(to_bottom,rgba(244,63,94,0.3)_1px,transparent_1px)] bg-[size:28px_28px]"
        />
      </div>

      {/* Gestochen scharfer Vordergrund */}
      <div className="relative z-10 flex flex-col items-center gap-2.5 antialiased">
        <div className="flex items-center gap-1.5 rounded-full border border-rose-400/60 bg-white px-3 py-1 font-mono text-[10px] font-bold text-neutral-700 shadow-md dark:bg-zinc-900 dark:text-neutral-200">
          <Link2 className="h-3 w-3 text-rose-500" />
          <span>lukiluki.dev/garden</span>
        </div>

        <motion.div
          animate={{
            y: unfurled ? -3 : 3,
            opacity: unfurled ? 1 : 0.65,
          }}
          transition={{ type: "spring", stiffness: 280, damping: 20 }}
          className="flex w-56 items-center gap-3 rounded-2xl border border-rose-400/80 bg-white p-2.5 shadow-[0_18px_36px_-6px_rgba(244,63,94,0.55)] dark:bg-zinc-900"
        >
          <div className="flex h-11 w-14 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-rose-500 to-amber-500 text-white shadow-md">
            <ImageIcon className="h-5 w-5" />
          </div>
          <div className="flex min-w-0 flex-col">
            <span className="truncate font-sans text-xs font-black text-neutral-900 dark:text-white">
              OpenGraph Card
            </span>
            <span className="flex items-center gap-1 font-mono text-[9px] font-bold text-emerald-600 dark:text-emerald-400">
              <CheckCircle2 className="h-3 w-3" />
              1200×630 Ready
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
